import { daysOfTheWeekS, generalHelpers } from '@monorepo/helpers';
import { Dispatch, FC, SetStateAction } from 'react';
import { helpers } from 'src/services';
import { Hr } from 'src/components/_commons';
import { MeetingAssignmentsButton } from './MeetingAssignmentsButton';
import { typeMeeting, typeMeetingsDoc, typeUser } from '@monorepo/models';
import { useGetConfig } from 'src/custom-hooks';
import { UserAssignmentsButton } from './UserAssignmentsButton';
import Select from 'react-select';

type propsType = {
    meeting: typeMeeting;
    meetingsDoc: typeMeetingsDoc | null;
    readOnly: boolean;
    setMeeting: Dispatch<SetStateAction<typeMeeting | null>>;
    type: 'midweek' | 'public';
    users: typeUser[];
    weekNumber: number;
    year: number;
};

export const Meeting: FC<propsType> = ({
    meeting, meetingsDoc, readOnly, setMeeting, type, users, weekNumber, year
}) => {
    const config = useGetConfig();
    const dateRange = helpers.GetCalendarWeekRange(weekNumber, year);

    return (
        <>
        {meetingsDoc &&
            <UserAssignmentsButton
                meetingsDoc={meetingsDoc}
                users={users}
            />
        }
        {meetingsDoc &&
            <MeetingAssignmentsButton
                label={type === 'midweek' ? 'REUNIONES DE ENTRESEMANA' : 'REUNIONES DE FIN DE SEMANA'}
                meetings={type === 'midweek' ? meetingsDoc.midweeks : meetingsDoc.publics}
            />
        }
        <div className={'container pt-4 pb-2 mt-3'} style={{ maxWidth: '230px' }}>
            {!readOnly && !meeting.date &&
                <p className={'text-center text-danger'}>
                    *La fecha es obligatoria
                </p>
            }
            <h5 className={'text-center'}>
                Fecha de la Reunión:
            </h5>
            <div className={'d-flex align-items-center gap-2'}>
                <input type={'date'}
                    className={'form-control text-center'}
                    value={meeting.date}
                    onChange={e => {
                        const v = e.target.value;
                        const _year = parseInt(v.split('-')[0]);
                        const date = generalHelpers.GetDateFromDateString(v);
                        setMeeting(m => ({
                            ...m!,
                            date: v,
                            weekday: date.getDay(),
                            weekNumber: generalHelpers.GetCalendarWeekNumber(date),
                            year: _year
                        }));
                    }}
                    min={dateRange.minDate}
                    max={dateRange.maxDate}
                    disabled={readOnly}
                />
                <span>
                    {meeting.date && daysOfTheWeekS[meeting.weekday].toUpperCase()}
                </span>
            </div>
        </div>
        {meeting.sections.map((section, i) =>
            <div key={i}>
                <h3 className={`${i === 2 ? 'bg-green' : i === 3 ? 'bg-yellow' : i === 4 ? 'bg-general-red' : 'bg-general-blue'} text-white py-1 ps-3 mt-4`}>
                    {section.title}
                </h3>
                {section.segments.map((segment, j) =>
                    <div key={j} className={'px-3'}>
                        <div>
                            {!!j && <hr />}
                            <h5 className={'mt-3'}>
                                {readOnly ?
                                    <>{segment.subtitle}</>
                                    :
                                    <input type={'text'}
                                        className={'form-control'}
                                        value={segment.subtitle}
                                        onChange={e => {
                                            const v = e.target.value;
                                            if (v.length >= 300) {
                                                return;
                                            }
                                            setMeeting(x => ({
                                                ...x!,
                                                sections: x!.sections.map((s, i1) => ({
                                                    ...s,
                                                    segments: s.segments.map((se, j1) => i === i1 && j === j1 ? ({
                                                        ...se,
                                                        subtitle: v
                                                    }) : se)
                                                }))
                                            }))
                                        }}
                                    />
                                }
                            </h5>
                        </div>
                        {segment.descriptions.map((description, k) => readOnly ?
                            <p key={k} className={'ps-3 my-1'}>
                                {description}
                            </p>
                            :
                            <input key={k}
                                type={'text'}
                                className={'form-control'}
                                value={description}
                                onChange={e => {
                                    const v = e.target.value;
                                    if (v.length >= 300) {
                                        return;
                                    }
                                    setMeeting(x => ({
                                        ...x!,
                                        sections: x!.sections.map((s, i1) => ({
                                            ...s,
                                            segments: s.segments.map((se, j1) => ({
                                                ...se,
                                                descriptions: se.descriptions.map((d, k1) => i === i1 && j === j1 && k === k1 ?
                                                    v
                                                    :
                                                    d
                                                )
                                            }))
                                        }))
                                    }))
                                }}
                            />
                        )}
                        <div className={'row mt-3'}>
                            {segment.assignments.map((a, l) =>
                                <div key={l} className={'col-md-3'}>
                                    {(!readOnly || a.user) &&
                                        <Select className={`text-dark ${!readOnly && a.user && [...meeting.sections.map(s => s.segments).flat().map(se => se.assignments).flat().map(a => a.user), ...meeting.avAssignments.map(a => a.user), ...meeting.usherAssignments.map(a => a.user)].filter(u => u).filter(u => u!.id === a.user!.id).length > 1 ? 'bg-danger-select' : ''} ${readOnly ? 'hide-arrow' : ''}`}
                                            options={users}
                                            getOptionLabel={u => u.id ? `${u.name} ${u.lastName}` : ''}
                                            getOptionValue={u => u?.id.toString()}
                                            placeholder={`${a.room === '1' ? 'Auditorio' : 'Sala Aux.'} ${a.isHelper ? ' - Ayudante' : ''}`}
                                            value={a.user}
                                            onChange={u => {
                                                if (readOnly) {
                                                    return;
                                                }
                                                setMeeting(x => ({
                                                    ...x!,
                                                    sections: x!.sections.map(s => ({
                                                        ...s,
                                                        segments: s.segments.map(se => ({
                                                            ...se,
                                                            assignments: se.assignments.map(_a => {
                                                                let aToSave = _a;
                                                                if (se.subtitle === segment.subtitle) {
                                                                    aToSave = _a.room === a.room && _a.isHelper === a.isHelper ?
                                                                        ({
                                                                            ..._a,
                                                                            user: u ?? null
                                                                        })
                                                                        :
                                                                        _a
                                                                    ;
                                                                }
                                                                return aToSave;
                                                            })
                                                        }))
                                                    }))
                                                }));
                                            }}
                                            isClearable
                                            // isDisabled={readOnly}
                                        />
                                    }
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        )}

        <Hr classes={'mt-5 mb-4'} />

        <div>
            <h3 className={'bg-general-blue text-white py-1 ps-3'}>
                AUDIO Y VIDEO
            </h3>
            <div className={'row px-3'}>
                {meeting.avAssignments.map(a =>
                    <div key={a.name} className={'col-md-4'}>
                        <div className={'my-2'}>
                            {a.name}:
                        </div>
                        <Select className={`text-dark ${!readOnly && a.user && [...meeting.sections.map(s => s.segments).flat().map(se => se.assignments).flat().map(a => a.user), ...meeting.avAssignments.map(a => a.user), ...meeting.usherAssignments.map(a => a.user)].filter(u => u).filter(u => u!.id === a.user!.id).length > 1 ? 'bg-danger-select' : ''} ${readOnly ? 'hide-arrow' : ''}`}
                            options={users}
                            getOptionLabel={u => `${u.name} ${u.lastName}`}
                            getOptionValue={u => u.id.toString()}
                            placeholder={a.name}
                            value={a.user}
                            onChange={u => {
                                if (readOnly) {
                                    return;
                                }
                                setMeeting(x => ({
                                    ...x!,
                                    avAssignments: x!.avAssignments.map(_a => {
                                        let aToSave = _a;
                                        if (_a.name === a.name) {
                                            aToSave = {
                                                ..._a,
                                                user: u ?? null
                                            };
                                        }
                                        return aToSave;
                                    })
                                }));
                            }}
                            isClearable
                            // isDisabled={readOnly}
                        />
                    </div>
                )}
            </div>
        </div>

        <Hr classes={'mt-5 mb-4'} />

        <div className={'pb-5'}>
            <h3 className={'bg-general-blue text-white py-1 ps-3'}>
                ACOMODADORES
            </h3>
            <div className={'row px-3'}>
                {meeting.usherAssignments.map(a =>
                    <div key={a.name} className={'col-md-4'}>
                        <div className={'my-2'}>
                            {a.name}:
                        </div>
                        <Select className={`text-dark ${!readOnly && a.user && [...meeting.sections.map(s => s.segments).flat().map(se => se.assignments).flat().map(a => a.user), ...meeting.avAssignments.map(a => a.user), ...meeting.usherAssignments.map(a => a.user)].filter(u => u).filter(u => u!.id === a.user!.id).length > 1 ? 'bg-danger-select' : ''} ${readOnly ? 'hide-arrow' : ''}`}
                            options={users}
                            getOptionLabel={u => `${u.name} ${u.lastName}`}
                            getOptionValue={u => u.id.toString()}
                            placeholder={a.name}
                            value={a.user}
                            onChange={u => {
                                if (readOnly) {
                                    return;
                                }
                                setMeeting(x => ({
                                    ...x!,
                                    usherAssignments: x!.usherAssignments.map(_a => {
                                        let aToSave = _a;
                                        if (_a.name === a.name) {
                                            aToSave = {
                                                ..._a,
                                                user: u ?? null
                                            };
                                        }
                                        return aToSave;
                                    })
                                }));
                            }}
                            isClearable
                            // isDisabled={readOnly}
                        />
                    </div>
                )}
            </div>
        </div>
        <Hr classes={'mt-5 mb-4'} />
        <div className={'pb-5'}>
            <h3 className={'bg-general-blue text-white py-1 ps-3 mb-4'}>
                LIMPIEZA
            </h3>
            {!!config.numberOfGroups ?
                <div className={'row px-3'}>
                    {readOnly ?
                        <>
                        {!!meeting.groupsForCleaning.length ?
                            meeting.groupsForCleaning.map((g, i) =>
                                <div key={i} className={'col-md-4'}>
                                    <select className={'form-control'}
                                        value={g}
                                        onChange={() => {}}
                                        disabled
                                    >
                                        <option value={''}>
                                            {/* Ninguno */}
                                        </option>
                                        {Array.from({ length: config.numberOfGroups}, (_, i) => i + 1).map(_g =>
                                            <option key={_g} value={_g} disabled={!!meeting.groupsForCleaning.includes(_g)}>
                                                Grupo {_g}
                                            </option>
                                        )}
                                    </select>
                                </div>
                            )
                            :
                            <p>
                                No se han establecido grupos de limpieza para esta reunión
                            </p>
                        }
                        </>
                        :
                        <>
                        {[1, 2, 3].map(option =>
                            <div key={option} className={'col-md-4'}>
                                <select className={'form-select'}
                                    value={meeting.groupsForCleaning[option - 1] || ''}
                                    onChange={e => {
                                        const v = parseInt(e.target.value) || 0;
                                        setMeeting((x): typeof x => ({
                                            ...x!,
                                            groupsForCleaning: [
                                                option === 1 ? v : x!.groupsForCleaning[0],
                                                option === 2 ? v : x!.groupsForCleaning[1],
                                                option === 3 ? v : x!.groupsForCleaning[2]
                                            ].filter(Boolean)
                                        }));
                                    }}
                                    disabled={!!meeting.groupsForCleaning.filter((g, _i) => _i < option - 1 && !g).length  || !!meeting.groupsForCleaning.filter((g, _i) => _i > option - 1 && !!g).length}
                                >
                                    <option value={''}>
                                        {/* Ninguno */}
                                    </option>
                                    {Array.from({ length: config.numberOfGroups}, (_, i) => i + 1).map(_g =>
                                        <option key={_g} value={_g} disabled={!!meeting.groupsForCleaning.includes(_g)}>
                                            Grupo {_g}
                                        </option>
                                    )}
                                </select>
                            </div>
                        )}
                        </>
                    }
                </div>
                :
                <p>
                    Para establecer asignaciones de limpieza del salón por grupos primero hay que establecer los grupos de predicación en su respectiva página (solo administradores generales)
                </p>
            }
        </div>
        </>
    );
}
